import { DataFieldType } from '@/app/[locale]/admin/lib/DataFieldType';
import { DataField } from '@/components/data/dataType';

export const formFields: DataField[] = [
    {
        name: 'name',
        i18n: false,
        title: { fr: 'Nom', en: 'Name' },
        defaultValue: '',
        dataType: DataFieldType.String,
        required: true,
        gridClass: '',
    },
    {
        name: 'title',
        i18n: true,
        title: { fr: 'Titre', en: 'Title' },
        defaultValue: '',
        dataType: DataFieldType.String,
        required: true,
        gridClass: '',
    },
    {
        name: 'dataType',
        i18n: false,
        title: { fr: 'Type', en: 'Type' },
        defaultValue: 'text',
        dataType: DataFieldType.SelectText,
        required: true,
        gridClass: '',
        dataList: {
            field: 'dataList',
            options: [
                { value: DataFieldType.String, label: 'Texte' },
                { value: DataFieldType.Number, label: 'Nombre' },
                { value: DataFieldType.Currency, label: 'Currency' },
                { value: DataFieldType.Email, label: 'Courriel' },
                { value: DataFieldType.Phone, label: 'Phone' },
                { value: DataFieldType.Boolean, label: 'Booléen' },
                { value: DataFieldType.SelectText, label: 'Liste déroulante' },
                { value: DataFieldType.Date, label: 'Date' },
                { value: DataFieldType.RadioList, label: 'Boutons radio' },
            ],
        },
    },
    {
        name: 'required',
        i18n: false,
        title: { fr: 'Requis', en: 'Required' },
        defaultValue: true,
        dataType: DataFieldType.Boolean,
        required: true,
        gridClass: '',
    },
    {
        name: 'requiredMessage',
        i18n: true,
        title: { fr: 'Message requis', en: 'Required Message' },
        defaultValue: 'Le champ est requis',
        dataType: DataFieldType.String,
        required: true,
        gridClass: '',
    },
    {
        name: 'invalidMessage',
        i18n: true,
        title: { fr: 'Message invalide', en: 'Invalid Message' },
        defaultValue: 'Le champ est invalide',
        dataType: DataFieldType.String,
        required: true,
        gridClass: '',
    },
    {
        name: 'position',
        i18n: false,
        title: { fr: 'Position', en: 'Position' },
        defaultValue: 0,
        dataType: DataFieldType.SortNumber,
        required: true,
        gridClass: '',
    },
    {
        name: 'enabled',
        i18n: false,
        title: { fr: 'Activé', en: 'Enabled' },
        defaultValue: true,
        dataType: DataFieldType.Boolean,
        required: true,
        gridClass: '',
    },
    {
        name: 'dataList',
        i18n: true,
        title: { fr: 'Liste', en: 'List' },
        defaultValue: [],
        dataType: DataFieldType.List,
        required: false,
        gridClass: '',
    },
];
